import { useLocalStorage } from "@vueuse/core";
import { defineStore } from "pinia";
export const useCommonStore = defineStore({
  id: "common",
  state: () => ({
    sidebarOpen: true,
    navbarOpen: true,
    isDark: useLocalStorage("vueuse-color-scheme"),
  }),
  getters: {
    getSidebar: (state) => {
      return state.sidebarOpen;
    },
    getIsDark: (state) => {
      return state.isDark;
    },
    getNavbar: (state) => {
      return state.navbarOpen;
    },
  },
  actions: {
    hideNavSidebar() {
      this.sidebarOpen = false;
      this.navbarOpen = false;
    },
    showNavSidebar() {
      this.sidebarOpen = true;
      this.navbarOpen = true;
    },
  },
});
